import type {
  AccountCancellationPolicyDto,
  AccountCancellationPolicyResponseDto,
} from '@shared/core/cancellation-policy'
import { useMutation, useQuery, useQueryClient, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { GET_APPOINTMENT_TYPES_CACHE_KEY } from 'src/modules/user/hooks/use-appointment-types'
import { ApiService } from 'src/services/api.service'
import { GET_CANCELLATION_POLICY_CACHE_KEY } from '../constants/cancellation-policy-cache-keys'
import { GET_LATE_CANCEL_COUNTS_CACHE_KEY } from './use-late-cancels'

export { GET_CANCELLATION_POLICY_CACHE_KEY }

export function useCancellationPolicy(options?: UseQueryOptions<AccountCancellationPolicyResponseDto>) {
  const handleRetry = useHandleRetry()

  return useQuery([GET_CANCELLATION_POLICY_CACHE_KEY], () => ApiService.CancellationPolicy.get(), {
    retry: handleRetry,
    ...options,
  })
}

export function useUpdateCancellationPolicy() {
  const queryClient = useQueryClient()
  return useMutation((dto: AccountCancellationPolicyDto) => ApiService.CancellationPolicy.update(dto), {
    onSuccess: (saved) => {
      queryClient.setQueryData([GET_CANCELLATION_POLICY_CACHE_KEY], saved)
      queryClient.invalidateQueries([GET_APPOINTMENT_TYPES_CACHE_KEY])
      queryClient.invalidateQueries([GET_LATE_CANCEL_COUNTS_CACHE_KEY])
    },
  })
}

export function useResetCancellationPolicyTypes() {
  const queryClient = useQueryClient()
  return useMutation(() => ApiService.CancellationPolicy.resetTypes(), {
    onSuccess: () => {
      queryClient.invalidateQueries([GET_CANCELLATION_POLICY_CACHE_KEY])
      queryClient.invalidateQueries([GET_APPOINTMENT_TYPES_CACHE_KEY])
      queryClient.invalidateQueries([GET_LATE_CANCEL_COUNTS_CACHE_KEY])
    },
  })
}
